import { createContext, useContext } from 'react';
export const FormViewContext = /*#__PURE__*/createContext(undefined);
export function useFieldView(fieldId) {
  const context = useFormView();
  const fieldView = context.fields.find(field => field.id === fieldId);
  return fieldView;
}
export function useFormView() {
  const context = useContext(FormViewContext);
  if (context === undefined) {
    throw new Error('useFormView must be used within a FormViewProvider');
  }
  return context;
}
//# sourceMappingURL=form-view-context.js.map